<div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="8px">
  <h2 fxFlex>Łącznie do opłacenia</h2>
  <div fxLayout="column">
    <span class="amount"
          [ngStyle]="{'margin-bottom': ( errorMsg.value === '' ? '15px' : '0')}">
      {{ payment?.liabilitiesAmountToPaySum || 0 | number: '1.2-2':'pl' }} zł
    </span>
    <mat-error *ngIf="errorMsg!==null && errorMsg.value !==null ">
      <span>
        <ng-container *ngIf="!errorMsg.url && errorMsg !=='' ;else errorLink">
          {{ errorMsg.value }}
        </ng-container>

        <ng-template #errorLink>
            <a style="font-weight: normal" class="error" [routerLink]="errorMsg.url" [state]="errorMsg.state">{{errorMsg.value}}</a>
        </ng-template>
      </span>
    </mat-error>
  </div>
  <mat-expansion-panel
    style=" box-shadow: none;"
    [disabled]="countPaymentFragments===0 || startedPayment" [expanded]="shoudBeExpanded()">
    <mat-expansion-panel-header>
      <mat-panel-title [ngStyle]="{'opacity': startedPayment? '0.4' : null}">
        <ng-container *ngIf="countPaymentFragments>0; else noLiabilitiesTitle">
          Wydatki do opłacenia
        </ng-container>
        <ng-template #noLiabilitiesTitle>
          Brak wydatków
        </ng-template>
      </mat-panel-title>
      <mat-panel-description *ngIf="countPaymentFragments>0" [ngStyle]="{'opacity': startedPayment? '0.4' : null}">
        {{ countPaymentFragments }}
      </mat-panel-description>
    </mat-expansion-panel-header>
    <ng-template matExpansionPanelContent>
      <div style="width: 100%;">
        <div *ngIf="startedPayment"
             style="width: 100%; position: absolute; display: flex;    justify-content: center; height: calc(100% - 39px)">
          <app-new-spinner [size]="50"></app-new-spinner>
        </div>
        <div class="panel-body" [ngStyle]="{'opacity': startedPayment? '0.4' : null}">
          <div style="padding: 0;" fxLayout="column">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px" class="text-me">
              <div class="w-90" style="padding-right: 8px; min-width: 250px">
                <h3 fxFlex="60" fxFlex.xs="60" class="text-right" fxLayoutGap="4px">Dostawca</h3>
                <h3 fxFlex="40" fxFlex.xs="40" class="text-right">Kwota</h3>
              </div>
            </div>

            <div class="liability-list" fxFlex fxFlex.lt-md="none">
              <div *ngIf="payment; else emptyLiabilityList">
                <div
                  class="liability-list-item"
                  [class.last]="last"
                  *ngFor="let fragment of payment.paymentFragments; let last = last"
                  fxLayout="row"
                  fxLayoutAlign="start center">
                  <div class="text-sm w-90"
                       [class.clickable-area]="!startedPayment && enableRedirectToFragment"
                       fxLayout="row"
                       fxLayoutAlign="start center"
                       matRipple
                       style=" min-width: 250px"
                       [ngStyle]="{'cursor': !startedPayment? 'pointer' : null}"

                       (click)="redirectToFragment(fragment.liability.id)">
                    <!--                     [class.full-row]="payment.status !== paymentStatus.CREATED"-->
                    <div class="provider-name text-right" fxFlex="60" fxFlex.xs="60" fxLayoutGap="4px"
                         [matTooltip]="!startedPayment ? 'Tytuł: ' + fragment.liability.title : null"
                    >
                      <span class="liability-item">{{ fragment.liability.billerName }}</span>
                    </div>


                    <div class="text-right" fxFlex="40" fxFlex.xs="40" style="">
                      <span class="liability-item">{{ fragment.amount | number: '1.2-2':'pl' }}&nbsp;zł</span>
                    </div>
                  </div>

                  <div
                    class="text-right delete-area liability-item"
                    fxFlex="13"
                    fxLayout="row"
                    fxLayoutAlign="center center"
                    matRipple
                    matRippleRadius="25"
                    matRippleCentered="true">
                    <app-new-loader-button
                      [matTooltip]="!startedPayment ? 'Usuń wydatek z koszyka' : null"
                      [loading]="buttonLoading" (buttonClick)="removeFromCart(payment, fragment)"
                      style="height: 24px" [disabled]="payment.status !== paymentStatus.CREATED">
                      <app-icon name="do_disturb"
                                [color]="'#575481'"
                                [width]="12" [height]="12"></app-icon>
                    </app-new-loader-button>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </ng-template>

  </mat-expansion-panel>
</div>


<mat-card-content fxLayout="column" fxLayoutAlign="start stretch" fxFlex fxFlex.lt-md="none">

  <div fxLayout="row" fxLayoutAlign="start stretch" fxFlex="none">
    <div class="summary" fxFlex fxLayout="column" fxLayoutAlign="center stretch">
      <app-coupon-select
        *ngIf="
            payment?.liabilitiesPaymentType !== LiabilitiesPaymentType.TOP_UP &&
            appConfig.config.features.activateCouponEnabled
          "
        [paymentData]="{
            paymentId: payment?.id,
            paymentStatus: payment?.status || PaymentStatus.CREATED
          }"
        [paymentCoupon]="payment?.couponId && { couponId: payment.couponId, amount: payment.couponAmount }"
        [emptyCartCouponId]="emptyCartCouponId"
      ></app-coupon-select>
    </div>
  </div>


</mat-card-content>

<ng-template #emptyLiabilityList>
  <app-empty-cart [selectedCouponId]="emptyCartCouponId"></app-empty-cart>
</ng-template>
